import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.reduce.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { I18N } from "../Shared/I18n";
export var DropdownBuilder = /*#__PURE__*/function () {
  function DropdownBuilder() {
    _classCallCheck(this, DropdownBuilder);

    this._locale = null;
  } // Removes all <option> elements from select and populates with data formatted as id, value


  _createClass(DropdownBuilder, null, [{
    key: "LoadDropdown",
    value: function LoadDropdown(selectElement, data, placeholder) {
      // Remove all dropdown options:
      for (var j = selectElement.options.length - 1; j >= 0; j--) {
        selectElement.remove(j);
      } // Create empty first item:


      var firstOpt = document.createElement("option");
      firstOpt.innerText = placeholder ? placeholder : "- All Records -";
      firstOpt.value = "";
      selectElement.appendChild(firstOpt); // Create option elements based on data:

      for (var i = 0; i < data.length; i++) {
        var opt = document.createElement("option");
        opt.value = data[i].id;
        opt.innerText = data[i].value || data[i].name;

        if (data[i].disabled) {
          opt.setAttribute("disabled", "");
          opt.style = "background-color: #d9d8d8";
        }

        selectElement.appendChild(opt);
      }
    } // Removes all <option> elements from select and populates with data formatted

  }, {
    key: "BuildDropdownWithOptGroup",
    value: function BuildDropdownWithOptGroup(selectElement, data, placeholder) {
      // Remove all dropdown optgroups and options:
      selectElement.innerHTML = "";

      var groupBy = function groupBy(keys) {
        return function (array) {
          return array.reduce(function (objectsByKeyValue, obj) {
            var value = keys.map(function (key) {
              return obj[key];
            });
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
          }, {});
        };
      };

      var groupByGroupName = groupBy(['groupName']);
      var attributeByGroupName = Object.keys(groupByGroupName(data));
      var firstOpt = document.createElement("option");
      firstOpt.innerText = placeholder ? placeholder : "- Select -";
      firstOpt.value = "";
      selectElement.appendChild(firstOpt);
      attributeByGroupName.forEach(function (groupName) {
        var optgroup = document.createElement("optgroup");
        optgroup.label = groupName;
        var attrs = data.filter(function (attr) {
          return attr.groupName === groupName;
        });

        for (var i = 0; i < attrs.length; i++) {
          var opt = document.createElement("option");
          opt.value = attrs[i].id;
          opt.innerText = attrs[i].name;
          optgroup.appendChild(opt);
        }

        selectElement.appendChild(optgroup);
      });
    } // Removes all <option> elements from select and populates with data formatted as id, value

  }, {
    key: "BuildCountryDropdown",
    value: function BuildCountryDropdown(selectElement, data, placeholder) {
      // Remove all dropdown options:
      for (var j = selectElement.options.length - 1; j >= 0; j--) {
        selectElement.remove(j);
      } // Create empty first item:


      var firstOpt = document.createElement("option");
      firstOpt.innerText = placeholder ? placeholder : "- All Records -";
      firstOpt.value = "";
      selectElement.appendChild(firstOpt); // Create option elements based on data:

      for (var i = 0; i < data.length; i++) {
        if (data[i].abbreviation) {
          var opt = document.createElement("option");
          opt.value = data[i].abbreviation;
          opt.innerText = data[i].value || data[i].name;

          if (data[i].abbreviation === 'US') {
            // move USA to top of optionsList
            selectElement.insertBefore(opt, selectElement[1]);
          } else {
            selectElement.appendChild(opt);
          }
        }
      }
    }
  }, {
    key: "_GetMonthBaseOnLocale",
    value: function _GetMonthBaseOnLocale(idx) {
      var objDate = new Date();
      objDate.setDate(1);
      objDate.setMonth(idx - 1);
      var month = objDate.toLocaleString(this._locale, {
        month: "long"
      });
      return month;
    }
  }, {
    key: "BuildMonthsList",
    value: function BuildMonthsList(selectElement, placeholder) {
      // Remove all dropdown options:
      for (var j = selectElement.options.length - 1; j >= 0; j--) {
        selectElement.remove(j);
      } // Create empty first item:


      var firstOpt = document.createElement("option");
      firstOpt.innerText = placeholder ? placeholder : "- All Records -";
      firstOpt.value = "";
      selectElement.appendChild(firstOpt);
      this._locale = I18N.GetCurrentLocale();
      var monthNames = [];

      for (var m = 1; m <= 12; m++) {
        monthNames.push(this._GetMonthBaseOnLocale(m));
      }

      for (var i = 0; i < monthNames.length; i++) {
        var opt = document.createElement("option");
        opt.value = i + 1;
        opt.innerText = monthNames[i];
        selectElement.appendChild(opt);
      }
    } // istanbul ignore next

  }, {
    key: "GetCurrentMonth",
    value: function GetCurrentMonth() {
      var date = new Date();
      return date.getMonth() + 1;
    }
  }, {
    key: "ReduceMonthDropDown",
    value: function ReduceMonthDropDown(selectElement, numberOfMonthsOut) {
      var month = this.GetCurrentMonth();
      var keptMonths = [];
      var monthValue = 0;

      for (var rr = 0; rr < numberOfMonthsOut; rr++) {
        monthValue = month + rr;

        if (monthValue > 12) {
          monthValue = monthValue - 12;
        }

        keptMonths.push(monthValue);
      }

      Array.from(selectElement.querySelectorAll("option")).forEach(function (opt) {
        var value = opt.value;
        var monthNumber = Number("+".concat(value));

        if (!!value && !keptMonths.includes(monthNumber)) {
          opt.disabled = true;
          opt.style.color = "#C0C0C0";
        }
      });
    }
  }]);

  return DropdownBuilder;
}();